
<div id="{{'GameRanking_' + uniqueid + '_' +PlayerId }}">

</div>
<div style="font-size: x-small;color: gray;">&nbsp;</div>
